var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.data.toolLink.length > 0)?_c('div',{staticClass:"linkbox"},_vm._l((_vm.params.data.toolLink),function(tlink,index){return _c('ElLink',{key:index,attrs:{"href":tlink.link,"target":"_blank","underline":false}},[_vm._v(_vm._s(tlink.name))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }